import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const AttendanceSvg = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_5709_52981)">
      <path
        d="M11 0C4.95 0 0 4.95 0 11C0 17.05 4.95 22 11 22C17.05 22 22 17.05 22 11C22 4.95 17.05 0 11 0ZM11 3.66667C13.0167 3.66667 14.6667 5.68333 14.6667 8.25C14.6667 10.8167
        13.0167 12.8333 11 12.8333C8.98333 12.8333 7.33333 10.8167 7.33333 8.25C7.33333 5.68333 8.98333 3.66667 11 3.66667ZM17.05 17.875C15.4917 19.25 13.2917 20.1667 11
        20.1667C8.70833 20.1667 6.50833 19.25 4.95 17.875C4.58333 17.5083 4.49167 16.9583 4.85833 16.5917C5.86667 15.4 7.24167 14.575 8.70833 14.1167C9.44167 14.4833 10.175 14.6667 11
        14.6667C11.825 14.6667 12.5583 14.4833 13.2917 14.1167C14.85 14.575 16.1333 15.4 17.1417 16.5917C17.5083 16.9583 17.5083 17.5083 17.05 17.875Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_5709_52981">
        <rect width="22" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const Attendance = (props: IIconProps) => <Icon component={AttendanceSvg} {...props} />;

export default Attendance;
